import firebase from "firebase/app";
import "firebase/auth";
import "firebase/firestore";
import "firebase/storage";
const firebaseConfig = {
  apiKey: "AIzaSyDf9yE6hCBeJJsbLsVAQWNe5_GlMal_gXE",
  authDomain: "cozydesk-861ed.firebaseapp.com",
  projectId: "cozydesk-861ed",
  storageBucket: "cozydesk-861ed.appspot.com",
  messagingSenderId: "91848862422",
  appId: "1:91848862422:web:f219e7d61288129f723777",
  measurementId: "G-SNR6C84ZEF",
};

// Initialize Firebase
firebase.initializeApp(firebaseConfig);
const firestore = firebase.firestore();
const auth = firebase.auth();
const storage = firebase.storage();
export { firestore, auth, storage };
